import { Button, H3, Img, P } from '@vgrubs/components';
import { Div } from '@vgrubs/components';
import { ReactNode } from 'react';

export const NoDataComponent = ({
  image,
  title,
  description,
  descriptionNode,
  height = 'calc(100vh - 400px)',
  heightSM = 'calc(100vh - 400px)',
  maxWidth = '100%',
  maxWidthSM = '100%',
  button,
  secondaryButton,
  imageWidth = '150px',
  imageWidthSM = '100px',
}: {
  image?: string;
  title?: string;
  description?: string;
  descriptionNode?: ReactNode;
  height?: string;
  heightSM?: string;
  maxWidth?: string;
  maxWidthSM?: string;
  button?: {
    text: string;
    onClick: () => void;
  };
  secondaryButton?: {
    text: string;
    onClick: () => void;
  };
  imageWidth?: string;
  imageWidthSM?: string;
}) => {
  return (
    <Div
      $flex
      $column
      $alignCenter
      $justifyCenter
      $minHeight={height}
      $minHeightSM={heightSM}
      $maxWidth={maxWidth}
      $maxWidthSM={maxWidthSM}
      $m="0 auto"
    >
      {image && (
        <Img alt="" $width={imageWidth} $widthSM={imageWidthSM} src={image} />
      )}
      {title && (
        <H3 $mt="20" $center $mb={'0'}>
          {title}
        </H3>
      )}
      {(description || descriptionNode) && (
        <P $mb="16" $mt="8" $center>
          {description}
          {descriptionNode}
        </P>
      )}
      {secondaryButton && (
        <Button
          $selected
          $mt="16"
          $darkBlue
          $w="230px"
          onClick={secondaryButton.onClick}
        >
          {secondaryButton.text}
        </Button>
      )}
      {button && (
        <Button $selected $w="230px" $mt="16" onClick={button.onClick}>
          {button.text}
        </Button>
      )}
    </Div>
  );
};
